import Chatbot, { createChatBotMessage } from "react-chatbot-kit";
import "react-chatbot-kit/build/main.css";
import config from "./config";
import MessageParser from "./messageParser";
import ActionProvider from "./actionProvider";
import "./customChatbotStyles.css";
import { FaExpand, FaCompress } from "react-icons/fa";
import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
const botName = "Excelrate Bot";

const ChatbotComponent = ({setChatWindowVisible}) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const loadMessages = () => {
    const messages = JSON.parse(localStorage.getItem("chat_messages"));

    if (messages) {
      return messages;
    }

    const full_name = localStorage.getItem("full_name") || "" ;

    return [createChatBotMessage(`Hi ${full_name}! How can I help you?`)];
  };

  const toggleFullscreen = () => {
    setIsFullScreen((prev) => !prev);
  };

  const toggleChatbot = () => {
    setChatWindowVisible((prev) => !prev);
  };

  const validateInput = (input) => {
    return input.trim().length > 0;
  };


  return (
    <div
      className={`chatbot-wrapper ${isFullScreen ? "chatbot-fullscreen" : ""}`}
    >
      {/* <div style={{display: 'flex', gap:'5px'}} > */}
      <button className="chatbot-toggle-btn" onClick={toggleFullscreen}>
        {isFullScreen ? <FaCompress /> : <FaExpand />}
      </button>
      <button className="chatbot-close-btn" onClick={toggleChatbot}>
        {<AiOutlineClose/>}
      </button>
      {/* </div> */}
      
      
      <Chatbot
        config={config}
        messageParser={MessageParser}
        actionProvider={ActionProvider}
        messageHistory={loadMessages()}
        validator={validateInput}
        autoFocus
      />
    </div>
  );
};
export default ChatbotComponent;
